import { useQuery, type UseQueryResult } from '@zg-rentals/react-query5';
import { RentalManagerUserFreemiumWebApiHandler_charge } from '@zg-rentals/ts-rental-manager-api-client';
import { getClient } from '@zg-rentals/ts-rental-manager-api-client/client';
import type {
  FreemiumChargeResponseWebDto,
  ListingAlias,
  RentalManagerPaymentProductType,
} from '@zg-rentals/ts-rental-manager-api-client';
import type { DatarouterError } from '@zg-rentals/web-base';

type UseChargeParams = {
  hostApp?: string;
  listingAlias: ListingAlias;
  productType: RentalManagerPaymentProductType;
};

const useCharge = (queryParams: UseChargeParams): UseQueryResult<FreemiumChargeResponseWebDto, DatarouterError> => {
  const { listingAlias, productType, hostApp } = queryParams;

  const queryFn = () =>
    RentalManagerUserFreemiumWebApiHandler_charge(
      { listingAlias, productType, hostApp },
      getClient()?.extend({ timeout: 5 * 60 * 1000 }),
    );

  const queryHook = useQuery<FreemiumChargeResponseWebDto, DatarouterError>({
    queryKey: ['useCharge', listingAlias],
    queryFn,
    enabled: false,
    staleTime: 0,
    retry: 0,
  });

  return queryHook;
};

export { useCharge };
